import { Category } from "./category";

export class CategoryCollection {
  private _items: Array<Category> = [];
  
  constructor(categories: any = null) {
    if (categories) {
      this.normalize(categories);
    }
  }  

  public normalize(categories: any = null) {
    for (let category of categories) {
      this._items.push(new Category(category));
    }
  }

  set items(value: Array<Category>) {
    this._items = value;
  }

  get items(): Array<Category> {
    return this._items;
  }

  itemsOrdered() {
    return this.items.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0)); 
  } 
}
